export const EMAIL_REGEX = /\S+@\S+\.\S+/;

export function isValidEmail(value) {
  const trimmed = String(value ?? "").trim();
  if (!trimmed) return true;
  return EMAIL_REGEX.test(trimmed);
}

export function getEmailValidationError(value, { required = false } = {}) {
  const trimmed = String(value ?? "").trim();
  if (!trimmed) return required ? "Email is required" : "";
  if (!EMAIL_REGEX.test(trimmed)) {
    return "Enter a valid email address (must include @)";
  }
  return "";
}

export const emailInputFieldProps = {
  type: "email",
  autoComplete: "email",
};
